import React, { Component } from 'react';
import uniqueId from 'lodash/uniqueId';
import { Field } from 'redux-form';

export default class CheckboxSwitch extends Component {
  constructor(props) {
    super(props);
    this.fieldInput = field => (
      <input
        {...field.input}
        className="c-switch__toggle"
        type="checkbox"
        id={field.id}
        checked={field.input.value}
        disabled={field.disabled}
        data-automation-id={`switch:${field.input.name}`}
      />
    );
    this.id = props.id || uniqueId('switch-');
  }

  render() {
    const { label, name, wrapperClass, onChange, disabled, labelOnTheRight } = this.props;
    if (!name) return null;
    return (
      <div className={wrapperClass}>
        <div className="c-switch u-inline-block u-align-middle">
          <div display-if={label && labelOnTheRight} className="c-switch__text u-mr-">{label}</div>
          <Field
            name={name}
            component={this.fieldInput}
            id={this.id}
            normalize={value => value || false}
            onChange={onChange}
            disabled={disabled}
          />
          <label className="c-switch__label" htmlFor={this.id} data-automation-id={`switchLabel:${name}`} />
          <div display-if={label && !labelOnTheRight} className="c-switch__text u-mr--">{label}</div>
        </div>
      </div>
    );
  }
}
